import React, { PureComponent } from "react";
import cx from "classnames";
//
import Icon from "./Icon";

const geo = navigator.geolocation;

export default class Distance extends PureComponent {
  static defaultProps = {
    icon: "my_location",
  };

  _locate = (ev) => {
    if (geo) {
      this.props.startLoading();

      geo.getCurrentPosition(this._onPosition, this._onPositionError);
    }
  };

  // https://developer.mozilla.org/en-US/docs/Web/API/Position
  _onPosition = (position) => {
    const { latitude: lat, longitude: lng } = position.coords;

    this.props.stopLoading();
    this.props.setUserLocation({ lat, lng });
  };

  // https://developer.mozilla.org/en-US/docs/Web/API/PositionError
  _onPositionError = ({ code, message }) => {
    this.props.setError({ error: code, message });
  };

  _cancelEvent = (ev) => {
    if (!this.props.distance) {
      ev.stopPropagation();
    }
  };

  trans(distance) {
    return `${distance.toFixed(1)} km away`;
  }

  renderPending() {
    return (
      <a className="u-link" onClick={this._locate}>
        calculate distance
      </a>
    );
  }

  renderArea(area, distance) {
    return (
      <span>
        {area}{" "}
        {distance !== null && (
          <small className="u-muted">({this.trans(distance)})</small>
        )}
        {distance === null && this.renderPending()}
      </span>
    );
  }

  render() {
    const { icon, area, distance, isPending, isModelLocated } = this.props;

    let className = this.props.className;

    let content;

    if (area) {
      content = this.renderArea(area, distance);
    } else if (distance) {
      content = this.trans(distance);
    } else if (!isPending) {
      content = this.renderPending();
    } else if (!isModelLocated) {
      className = cx(className, "u-muted");
      content = "Distance not available";
    } else {
      /* Should never happen... */
    }

    return (
      <div className={className} onClick={this._cancelEvent}>
        {typeof icon === "string" && <Icon xsmall name={icon} />}
        {content}
      </div>
    );
  }
}
